import React, { FC, ReactNode, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Router } from '../router/Router';
import { getAuthToken } from '../utils/APIConfig';
import { useMainContext } from '../context/MainContext';

interface AuthProviderProps {
  children: ReactNode;
}

export const AuthProvider: FC<AuthProviderProps> = ({ children }) => {
  const navigation = useNavigate();
  const { profile } = useMainContext();

  const handleNotUser = () => Router(navigation).goToWelcome();
  const handleCSDRepresentative = () => Router(navigation).goToWelcomeCSD();

  useEffect(() => {
    const token = getAuthToken();
    if (token == null) {
      handleNotUser();
      return;
    }
    if (profile && profile.is_csd_representative) {
      handleCSDRepresentative();
    }
  }, [profile]);
  return (
    <div>
      {children}
    </div>
  );
};
